import React from 'react';
import {
  Divider as ModeDivider,
  type DividerProps as ModeDividerProps,
} from '@stitch-fix/mode-react';

export type DividerProps = Pick<ModeDividerProps, 'variant'>;

export const Divider = ({ variant }: DividerProps) => (
  <ModeDivider variant={variant} mx={1.5} />
);
